import  { Spinner}  from './Spinner.Styles'

export default Spinner